/* VAXA — menu drawer helpers.
   Three jobs only:
   1. Give the panel its own "Menu" row and close button. The header hamburger
      sits underneath the open panel, so it cannot be the way out. Built here
      rather than in header-drawer.liquid so that snippet stays stock Dawn.
   2. Mirror the drawer's open state onto <body> so CSS can lock scrolling and
      cancel the sticky header's transform (a transform on an ancestor would
      otherwise trap the fixed panel).
   3. Wire that close button to Dawn's own close animation. */
(function () {
  if (window.__vxDrawer) return;
  window.__vxDrawer = true;

  var DETAILS_ID = 'Details-menu-drawer-container';

  function buildTopRow() {
    var inner = document.querySelector('#menu-drawer .menu-drawer__inner-container');
    if (!inner || inner.querySelector('.vx-drawer__top')) return;

    var top = document.createElement('div');
    top.className = 'vx-drawer__top';
    top.innerHTML =
      '<span class="vx-drawer__title">Menu</span>' +
      '<button type="button" class="vx-drawer__close" aria-label="Close menu">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg></button>';

    inner.insertBefore(top, inner.firstChild);
  }

  function init() {
    var details = document.getElementById(DETAILS_ID);
    if (!details) return;

    buildTopRow();

    // Locking the page hides the scrollbar, which widens the body and shoves
    // everything sideways. CSS hands this width back as padding so nothing
    // moves. It has to be measured while the page is still unlocked: Dawn adds
    // its own overflow-hidden class during the click, before the open attribute
    // flips, so measuring on open would always read zero.
    var measureScrollbar = function () {
      if (details.hasAttribute('open')) return;
      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.setProperty('--vx-scrollbar', gap + 'px');
    };

    measureScrollbar();
    window.addEventListener('load', measureScrollbar);
    window.addEventListener('resize', measureScrollbar);

    var sync = function () {
      document.body.classList.toggle('vx-drawer-open', details.hasAttribute('open'));
    };

    new MutationObserver(sync).observe(details, {
      attributes: true,
      attributeFilter: ['open'],
    });
    sync();

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest('.vx-drawer__close');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      // Clicking the summary is what runs Dawn's close animation. Calling it
      // directly keeps the slide-out and the focus handling intact.
      var summary = details.querySelector(':scope > summary');
      if (details.hasAttribute('open') && summary) summary.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
